export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1551621955-fa07d4b1376b?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  heroAlt: "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
  editorialDoor: "https://images.unsplash.com/photo-1567777301743-3b7ef158aadf?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
  womenBlack: "https://images.unsplash.com/photo-1568251478083-32c27296c2c2?crop=entropy&cs=srgb&fm=jpg&q=90&w=1000",
  founder: "https://images.unsplash.com/photo-1734431196511-f0231f9f5b0d?crop=entropy&cs=srgb&fm=jpg&q=90&w=1000",
  founderAlt: "https://images.unsplash.com/photo-1733731402869-57e0cce24aea?crop=entropy&cs=srgb&fm=jpg&q=90&w=1000",
  atelier1: "https://images.unsplash.com/photo-1705970268643-ee5981567df5?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
  atelier2: "https://images.unsplash.com/photo-1457972657980-4c9fddebec8d?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
  atelier3: "https://images.unsplash.com/photo-1560796952-f1c9b838544c?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
};

export const COLLECTIONS = [
  {
    id: "women",
    index: "01",
    title: "Women",
    tagline: "Silhouettes of quiet power",
    desc: "Draped, tailored and hand-finished pieces for the modern woman — where heritage craft meets a contemporary edge.",
    image: "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    pieces: "24 pieces",
  },
  {
    id: "men",
    index: "02",
    title: "Men",
    tagline: "Tailoring, reimagined",
    desc: "Sharp, considered menswear built on precise measurement and refined fabric — suits, sherwanis and everyday luxury.",
    image: "https://images.unsplash.com/photo-1546572797-e8c933a75a1f?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    pieces: "18 pieces",
  },
  {
    id: "custom",
    index: "03",
    title: "Custom Creations",
    tagline: "Made only for you",
    desc: "A one-to-one atelier experience. Your idea, our craft — garments patterned, cut and stitched to your exact vision.",
    image: "https://images.unsplash.com/photo-1705970268643-ee5981567df5?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    pieces: "Bespoke",
  },
  {
    id: "festive",
    index: "04",
    title: "Festive & Occasion",
    tagline: "For the moments that matter",
    desc: "Opulent festive and occasion wear — embroidered, embellished and made to be remembered.",
    image: "https://images.unsplash.com/photo-1571908599407-cdb918ed83bf?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    pieces: "30 pieces",
  },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1568252542512-9fe8fe9c87bb?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Women", tall: true },
  { src: "https://images.unsplash.com/photo-1546572797-e8c933a75a1f?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Men" },
  { src: "https://images.unsplash.com/photo-1668371679302-a8ec781e876e?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Festive" },
  { src: "https://images.unsplash.com/photo-1676278746061-c5bac5b34ae5?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Men", tall: true },
  { src: "https://images.unsplash.com/photo-1571587289339-cb7da03fb5a6?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Festive" },
  { src: "https://images.unsplash.com/photo-1567777301743-3b7ef158aadf?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Women" },
  { src: "https://images.unsplash.com/photo-1705970268643-ee5981567df5?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Custom" },
  { src: "https://images.unsplash.com/photo-1568251478083-32c27296c2c2?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Women", tall: true },
  { src: "https://images.unsplash.com/photo-1645035828708-789028bb9782?crop=entropy&cs=srgb&fm=jpg&q=90&w=900", cat: "Men" },
];

export const MANIFESTO = [
  { n: "01", title: "Crafted with purpose", body: "Every Arkaari piece begins with intention. Nothing is mass-produced; everything is considered — from the first sketch to the final stitch." },
  { n: "02", title: "Handcrafted, always", body: "Our garments are shaped by hand in a small atelier, honouring the slow craft of Indian tailoring and the people who keep it alive." },
  { n: "03", title: "Worn with grace", body: "We design for the way you move and the moments you live in — clothing that feels as considered as it looks." },
];

export const CATEGORIES = ["All", "Women", "Men", "Custom", "Festive"];
